import { Col, Image, Row } from "react-bootstrap"
import bill from '../../../../assets/images/logo6-small.png'
import fitplus from '../../../../assets/images/fitPlusLogo.png'
import { useSelector } from "react-redux";


const SideBarHeader = () => {
    const { tenants } = useSelector((state) => state?.auth);
    return (
        <>
            {tenants[0]?.flavor == "fitplusclub" ? <Row>
                <Col lg={12} className="d-flex justify-content-center py-4 " style={{ borderBottom: '1px solid lightgray' }}>
                    <Image src={fitplus} height={60} width={100} />
                </Col>
            </Row> : <Row>
                <Col lg={12} className="d-flex justify-content-center py-4" style={{ borderBottom: '1px solid lightgray' }}>
                    <Image src={bill} height={50} />
                </Col>
            </Row>}
        </>
    )
}

export default SideBarHeader;